export enum LAYOUT_MODES {
  LIGHT = "light",
  DARK = "dark",
}
export enum CHATS_TABS {
  ARCHIVE = "acrhive",
  DEFAULT = "default",
}

export enum TABS {
  // CALLS = "pills-calls",
  // CONTACTS = "pills-contacts",
  // BOOKMARK = "pills-bookmark",
  USERS = "pills-user",
  CHAT = "pills-chat",
  SETTINGS = "pills-setting",
}
